module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAApkAAAAIBAMAAABAJPmuAAAAIVBMVEVHcEx1qf91qf91qf91qf/+amr+amr+amr+amp1qf/+amq5q6iXAAAACXRSTlMAv0DAP0DAP78Dm1FsAAAAX0lEQVRIx2NgYGCZiQQmM8BA1SokkAATHVVMQDEjstAkuP4uZP0BMNFRxQQUeyILGcAUsiNrXwY3dVQxAcWSyEIKMIUcyPqXwvWPKsaveLQkHC02R4vN0WJztCQkRTEADnjR8t7bxWcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/underline.png
// module id = MA+x
// module chunks = 37